import CheckboxSel from './components/CheckboxSel';
import ImgSelect from './components/ImgSelect';
import MySelect from './components/MySelect';
import RadioGroupSel from './components/RadioGroupSel';
import RadioGroupSelButtons from './components/RadioGroupSelButtons';


export const ComponentsMapDefault = {
    Select: MySelect,
    RadioGroupSel: RadioGroupSel,
    RadioGroupSelButtons: RadioGroupSelButtons,
    ImgSelect: ImgSelect,
    CheckboxSel: CheckboxSel,
};

export const uiTypeMap = {
    default: ComponentsMapDefault,
};
